import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const StopCircleSVG = ({
  fill = '#E5240B',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      {...otherSvgProps}
    >
      <path
        fill={fill}
        d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
      ></path>
      <path
        fill="#fff"
        d="M10.667 13.333a2.667 2.667 0 012.666-2.666h5.334a2.667 2.667 0 012.666 2.666v5.334a2.667 2.667 0 01-2.666 2.666h-5.334a2.667 2.667 0 01-2.666-2.666v-5.334z"
      ></path>
    </svg>
  </span>
);

export default StopCircleSVG;
